"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DogearedDocument = void 0;
var React = require("react");
var DogearedDocument = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: style },
        React.createElement("defs", null,
            React.createElement("path", { 
                // tslint:disable-next-line:max-line-length
                d: "M15,4 L19,8 L15,8 L15,4 Z M13,10 L19,10 L19,19 C19,19.6 18.6,20 18,20 L6,20 C5.4,20 5,19.6 5,19 L5,5 C5,4.4 5.4,4 6,4 L13,4 L13,10 Z", id: "DOGEARED_DOCUMENT_SVG_PATH" })),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "DOGEARED_DOCUMENT_SVG_MASK", fill: "white" },
                React.createElement("use", { xlinkHref: "#DOGEARED_DOCUMENT_SVG_PATH" })),
            React.createElement("g", { fillRule: "nonzero" }),
            React.createElement("g", { mask: "url(#DOGEARED_DOCUMENT_SVG_MASK)", fill: "#00242D" },
                React.createElement("rect", { x: "0", y: "0", width: "24", height: "24" })))));
};
exports.DogearedDocument = DogearedDocument;
//# sourceMappingURL=DogearedDocument.js.map